export default __webpack_public_path__ + "static/media/ASSETS-16.76661e01.png";